export class Scoreboard {
    constructor() {
        this.storageKey = 'tetris-scores';
        this.maxScores = 25;
        this.maxUsernameLength = 7;
        this.scores = this.loadScores();
    }

    loadScores() {
        try {
            const stored = localStorage.getItem(this.storageKey);
            return stored ? JSON.parse(stored) : [];
        } catch (error) {
            console.error('Error loading scores:', error);
            return [];
        }
    }

    saveScores() {
        try {
            localStorage.setItem(this.storageKey, JSON.stringify(this.scores));
        } catch (error) {
            console.error('Error saving scores:', error);
        }
    }

    validateUsername(username) {
        if (!username || typeof username !== 'string') return false;

        // Remove any non-alphanumeric characters and limit to 7 characters
        const cleanUsername = username.replace(/[^a-zA-Z0-9]/g, '').toUpperCase().slice(0, this.maxUsernameLength);

        return cleanUsername.length > 0 ? cleanUsername : 'PLAYER';
    }

    isTopScore(score) {
        if (this.scores.length < this.maxScores) return true;
        return score > this.scores[this.scores.length - 1].score;
    }

    addScore(username, score, level, lines) {
        const cleanUsername = this.validateUsername(username);

        const newScore = {
            username: cleanUsername,
            score: score,
            level: level,
            lines: lines,
            date: new Date().toISOString(),
            timestamp: Date.now()
        };

        // Add to scores array
        this.scores.push(newScore);

        // Sort by score (highest first)
        this.scores.sort((a, b) => b.score - a.score);

        // Keep only top 25 scores
        this.scores = this.scores.slice(0, this.maxScores);

        // Save to localStorage
        this.saveScores();

        return this.scores.findIndex(s => s.timestamp === newScore.timestamp) + 1;
    }

    getScores() {
        return [...this.scores];
    }

    getTopScore() {
        return this.scores.length > 0 ? this.scores[0].score : 0;
    }

    clearScores() {
        this.scores = [];
        this.saveScores();
    }

    // Sample scores removed - start with empty scoreboard

    formatScore(score) {
        return score.toString().padStart(8, '0');
    }

    formatDate(dateString) {
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', {
            month: 'short',
            day: 'numeric',
            year: 'numeric'
        });
    }
} 